<template>
	<header>
		<figure>
			<img src="../assets/img/ann-reinking.jpg" alt="Ann Reinking - Enhanced Photo: Original Photo Martha Swope ©NYPL
">
			<figcaption>Enhanced Photo: Original Photo Martha Swope &copy;NYPL</figcaption>
		</figure>
		<h1>Ann Reinking Scholarship<br> Grant Application</h1>
	</header>
	<div id="form-apply">
		<div id="intro">

			<p>
				Thank you for your interest in applying for the Ann Reinking Scholarship Program. Unfortunately, you have missed the deadline and we are no longer accepting applications for the 2021 award. <a target="_blank" href="https://offthelane.us4.list-manage.com/subscribe/post?u=6bf979eba60f22015654a15b8&id=d56824cb4e">Click here</a> to join the Off The Lane mailing list to stay up to date on all of our programming, including next year’s Ann Reinking Scholarship Application Dates! We look forward to connecting with you! 
			</p>

			<!-- <p>Thank you for applying for the Ann Reinking Scholarship Program. Our mission is to help set a young artist up for success by providing monetary support, mentorship, and a community and network of industry professionals to help lay the foundation for budding dancers moving to NYC to pursue their professional artistic careers.</p>

			<p>While we understand that a career in dance involves ongoing, lifelong training and constant evolution, matriculation in a college program precludes eligibility for this scholarship, which is geared towards a professional dancer, ready to launch a career. </p>

			<p>If you are enrolled in school/college in NYC for the 21/22 academic year, you are not eligible.</p>

			<p>If you are currently enrolled in college for the 21/22 year outside of NYC, you must be ready to move to NYC in the coming months to actively pursue your career.</p>

			<p>If you are currently enrolled in college, please reapply when you are ready to make your move to NYC.</p>

			<p>If you are moved forward to the 2nd Tier of Applications, you will be required to provide additional information. Check our <a href="https://offthelane.org/ann-reinking-scholarship-program/requirements/" target="_blank">Requirements Page</a> to learn more.</p>

			<p>Should you have any questions during the application process, please contact <a href="mailto:annreinkingscholarship@offthelane.org">annreinkingscholarship@offthelane.org</a>.</p>

			<p>Applications are due by June 30, 2021.</p>

			<p class="note">Be sure to use a modern web browser when filling out this application:<br />Latest Chrome, Firefox, Safari, or Edge</p> -->

		</div>
		<form-apply style="display:none;"
			v-on:save-applicant="saveApplicant"
			v-bind:isLoading="isLoading"
			v-bind:applicant="applicantRec"
			crud="add"
		>
		</form-apply>
	</div>
</template>
<script>
import FormApply from '../components/FormApply.vue'
export default {
	components: { FormApply },
	data() {
		return {
			isLoading: false,
			applicantRec: {
				address: {},
				otherInc: {},
				videoGoal: {},
				videoDance: {},
				materials: {}
			}
		}
	},
	methods: {
		async saveApplicant(data){
			this.isLoading = true

			try {
				console.log('sending app')
				await this.$store.dispatch('addApplicant',data)
				console.log('app sending done?')
				this.$router.replace('/received')
				console.log('change route')
			}
			catch(err) {
				alert(err)
			} 
			finally {
				this.isLoading = false
			}
		}
	}
}
</script>
<style scoped>
#form-apply {
	padding: 15px;
	padding-top: 0;
}

header figure {
	margin: 0;
	padding: 0;
}

header h1 {
	margin-top: 2.1rem;
	margin-bottom: 2.1rem;
	padding-right: 3px;
	padding-left: 3px;
	text-align: center;
}

	figure {
		position: relative;
	}

		figcaption {
			background-color: rgba(0,0,0,.3);
			color: #fff;
			right: 6px;
			bottom: 6px;
			opacity: .81;
			padding: 6px;
			font-size: 1.11rem;
			position: absolute;
			text-align: center;
			position: absolute;
		}

header img {
	object-fit: cover;
	width: 100vw;
	height: auto;
	max-height: 87vh;
}

#intro {
	border: 1px solid rgba(72,55,81,.3);
	padding: 15px;
}

#intro,
form {
	margin: 0 auto;
	max-width: 450px;
}

#intro {
	margin-bottom: 6rem;
}

.note {
	font-size: 1.2rem;
}
</style>